import React from 'react'

import Head from 'components/common/Head'
import { useGoogleAnalyticsId } from 'hooks/useEnv'

const GoogleAnalytics: React.FC = () => {
  const googleAnalytics4Id = useGoogleAnalyticsId()

  return (
    <Head>
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${googleAnalytics4Id}`}></script>
      <script>
        {`window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());

        gtag('config', '${googleAnalytics4Id}');`}
      </script>
    </Head>
  )
}

export default GoogleAnalytics
